import axios from "axios";

const BASE_URL = 'https://consultaprocesos.ramajudicial.gov.co:448/api/v2'

export default axios.create({
  baseURL: BASE_URL,
  timeout: 50000,
});


